module.exports = __webpack_public_path__ + "static/z_tall_employee-908cce94a2d4fe3d33d8c84908524782.jpg";